import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

interface SectionTitleProps {
  children: ReactNode
  className?: string
}

/** Centered Kalnia section heading used across the landing sections. */
export function SectionTitle({ children, className }: SectionTitleProps) {
  return (
    <h2
      data-slot="section-title"
      className={cn(
        "text-center font-display text-2xl font-medium leading-tight text-purple-light",
        className,
      )}
    >
      {children}
    </h2>
  )
}
